import { Injectable } from '@angular/core';
import { SearchItem } from '../../../../models/search-item';

import { createAction, props, Store } from '@ngrx/store';
import {ISearchItemsAction} from '../../../search-item/search-items-action-interface';

export class WkfSupervisionSearchItemsActionConstantAction {
  static readonly ADD_WKF_SUPERVISION_SEARCH_ITEM_START = 'ADD_WKF_SUPERVISION_SEARCH_ITEM_START';
  static readonly ADD_WKF_SUPERVISION_SEARCH_ITEM_SUCCEEDED = 'ADD_WKF_SUPERVISION_SEARCH_ITEM_SUCCEEDED';
  static readonly ADD_WKF_SUPERVISION_SEARCH_ITEM_FAILED = 'ADD_WKF_SUPERVISION_SEARCH_ITEM_FAILED';

  static readonly REMOVE_WKF_SUPERVISION_SEARCH_ITEM_START = 'REMOVE_WKF_SUPERVISION_SEARCH_ITEM_START';
  static readonly REMOVE_WKF_SUPERVISION_SEARCH_ITEM_SUCCEEDED = 'REMOVE_WKF_SUPERVISION_SEARCH_ITEM_SUCCEEDED';
  static readonly REMOVE_WKF_SUPERVISION_SEARCH_ITEM_FAILED = 'REMOVE_WKF_SUPERVISION_SEARCH_ITEM_FAILED';

  static readonly ADD_WKF_SUPERVISION_SEARCH_ITEMS_START = 'ADD_WKF_SUPERVISION_SEARCH_ITEMS_START';
  static readonly ADD_WKF_SUPERVISION_SEARCH_ITEMS_SUCCEEDED = 'ADD_WKF_SUPERVISION_SEARCH_ITEMS_SUCCEEDED';
  static readonly ADD_WKF_SUPERVISION_SEARCH_ITEMS_FAILED = 'ADD_WKF_SUPERVISION_SEARCH_ITEMS_FAILED';

  static readonly SET_WKF_SUPERVISION_SEARCH_ITEMS_START = 'SET_WKF_SUPERVISION_SEARCH_ITEMS_START';
  static readonly SET_WKF_SUPERVISION_SEARCH_ITEMS_SUCCEEDED = 'SET_WKF_SUPERVISION_SEARCH_ITEMS_SUCCEEDED';
  static readonly SET_WKF_SUPERVISION_SEARCH_ITEMS_FAILED = 'SET_WKF_SUPERVISION_SEARCH_ITEMS_FAILED';

  static readonly REMOVE_ALL_WKF_SUPERVISION_SEARCH_ITEMS_SUCCEEDED = 'REMOVE_ALL_WKF_SUPERVISION_SEARCH_ITEMS_SUCCEEDED';
}

export const addWkfSupervisionSearchItemStartAction           = createAction(WkfSupervisionSearchItemsActionConstantAction.ADD_WKF_SUPERVISION_SEARCH_ITEM_START);
export const addWkfSupervisionSearchItemSucceededAction       = createAction(WkfSupervisionSearchItemsActionConstantAction.ADD_WKF_SUPERVISION_SEARCH_ITEM_SUCCEEDED, props<{payload:SearchItem}>());
export const addWkfSupervisionSearchItemFailedAction          = createAction(WkfSupervisionSearchItemsActionConstantAction.ADD_WKF_SUPERVISION_SEARCH_ITEM_FAILED, props<{error:Error}>());
export const removeWkfSupervisionSearchItemStartAction        = createAction(WkfSupervisionSearchItemsActionConstantAction.REMOVE_WKF_SUPERVISION_SEARCH_ITEM_START);
export const removeWkfSupervisionSearchItemSucceededAction    = createAction(WkfSupervisionSearchItemsActionConstantAction.REMOVE_WKF_SUPERVISION_SEARCH_ITEM_SUCCEEDED, props<{payload:SearchItem}>());
export const removeWkfSupervisionSearchItemFailedAction       = createAction(WkfSupervisionSearchItemsActionConstantAction.REMOVE_WKF_SUPERVISION_SEARCH_ITEM_FAILED, props<{error:Error}>());
export const removeAllWkfSupervisionSearchItemsSucceededAction = createAction(WkfSupervisionSearchItemsActionConstantAction.REMOVE_ALL_WKF_SUPERVISION_SEARCH_ITEMS_SUCCEEDED);
export const addWkfSupervisionSearchItemsStartAction           = createAction(WkfSupervisionSearchItemsActionConstantAction.ADD_WKF_SUPERVISION_SEARCH_ITEMS_START);
export const addWkfSupervisionSearchItemsSucceededAction       = createAction(WkfSupervisionSearchItemsActionConstantAction.ADD_WKF_SUPERVISION_SEARCH_ITEMS_SUCCEEDED, props<{payload:SearchItem[]}>());
export const addWkfSupervisionSearchItemsFailedAction          = createAction(WkfSupervisionSearchItemsActionConstantAction.ADD_WKF_SUPERVISION_SEARCH_ITEMS_FAILED, props<{error:Error}>());
export const setWkfSupervisionSearchItemsStartAction           = createAction(WkfSupervisionSearchItemsActionConstantAction.SET_WKF_SUPERVISION_SEARCH_ITEMS_START);
export const setWkfSupervisionSearchItemsSucceededAction       = createAction(WkfSupervisionSearchItemsActionConstantAction.SET_WKF_SUPERVISION_SEARCH_ITEMS_SUCCEEDED, props<{payload:SearchItem[]}>());
export const setWkfSupervisionSearchItemsFailedAction          = createAction(WkfSupervisionSearchItemsActionConstantAction.SET_WKF_SUPERVISION_SEARCH_ITEMS_FAILED, props<{error:Error}>());

@Injectable({
  providedIn: 'root'
})
export class WkfSupervisionSearchItemsAction implements ISearchItemsAction {

  constructor( private localStore: Store ) {
  }

  public addSearchItemStarted() {
    this.localStore.dispatch(addWkfSupervisionSearchItemStartAction());
  }

  public addSearchItemSucceeded(payload: SearchItem) {
    this.localStore.dispatch(addWkfSupervisionSearchItemSucceededAction({payload}));
  }

  public addSearchItemFailed(error: any) {
    this.localStore.dispatch( addWkfSupervisionSearchItemFailedAction({error}))

  }

  public removeSearchItemStarted() {
    this.localStore.dispatch(removeWkfSupervisionSearchItemStartAction());
  }

  public removeSearchItemSucceeded(payload: SearchItem) {
    this.localStore.dispatch(removeWkfSupervisionSearchItemSucceededAction({payload}));
  }

  public removeSearchItemFailed(error: any) {
    this.localStore.dispatch(removeWkfSupervisionSearchItemFailedAction({error}));
  }

  public removeAllSearchItemsSucceeded() {
    this.localStore.dispatch(removeAllWkfSupervisionSearchItemsSucceededAction());
  }

  addSearchItemsStarted(): void {
    this.localStore.dispatch(addWkfSupervisionSearchItemsStartAction());
  }

  addSearchItemsSucceeded( payload: SearchItem[] ): void {
    this.localStore.dispatch(addWkfSupervisionSearchItemsSucceededAction({payload}));
  }

  addSearchItemsFailed(error: any) {
    this.localStore.dispatch( addWkfSupervisionSearchItemsFailedAction({error}))
  }

  setSearchItemsStarted(): void {
    this.localStore.dispatch(setWkfSupervisionSearchItemsStartAction());
  }

  setSearchItemsSucceeded( payload: SearchItem[] ): void {
    this.localStore.dispatch(setWkfSupervisionSearchItemsSucceededAction({payload}));
  }

  setSearchItemsFailed(error: any) {
    this.localStore.dispatch( setWkfSupervisionSearchItemsFailedAction({error}))
  }
}
